module.exports = __webpack_public_path__ + "static/random-sculpture-desktop2-0cd398be751b5a2a43d902f307ca076f.png";